import { Injectable } from '@angular/core';


@Injectable()
export class ColorCategoriesData {

    public categoryColors: { [key: string]: string };
    public availableColors: string[];

    constructor() {
        this.initColors();
        this.initCategoryColors();
    }

    private initColors() {
        this.availableColors = [
            '#abd0f2',
            '#4768fd',
            '#574ddd',
            '#8da0fc',
            '#27e5fd',
            '#069f86',
            '#39c79d',
            '#ff4081',
            '#94dd6b',
            '#bbf5cb',
            '#31e7b6',
            '#feebb6',
            '#fcd230',
            '#e8bc4f',
            '#fd9127',
            '#ff6c00',
            '#ff9e80',
            '#fabfa9',
            '#BDBDBD',
            '#FF5722',
            '#4CAF50',
            '#673AB7',
            '#3F51B5',
            '#2196F3',
            '#BA68C8',
            '#EC407A',
            '#2E7D32',
            '#8D6E63',
            '#90A4AE',
            '#C2185B'
        ];
    }

    private initCategoryColors() {
        this.categoryColors = {
            'Sports': '#abd0f2',
            'Entrepreneurship': '#4768fd',
            'Music': '#574ddd',
            'Social Media': '#8da0fc',
            'Economy': '#27e5fd',
            'Photography': '#069f86',
            'Art demo': '#39c79d',
            'Media': '#ff4081',
            'Technology': '#94dd6b',
            'Food': '#bbf5cb',
            'Wake Up': '#31e7b6',
            'Business': '#feebb6',
            'Freelancing': '#fcd230',
            'Marketing': '#e8bc4f',
            'Productivity': '#fd9127',
            'Work': '#ff6c00',
            'Artificial intelligence': '#ff9e80',
            'Cryptocurrency': '#fabfa9',
            'Comics': '#BDBDBD',
            'Creativity': '#FF5722',
            'Family': '#4CAF50',
            'Health': '#673AB7',
            'Personal Finance': '#3F51B5',
            'Relationships': '#2196F3',
            'Travel': '#BA68C8',
            'Education': '#EC407A',
            'Environment': '#2E7D32',
            'Culture': '#8D6E63',
            'World': '#90A4AE',
            'Film': '#C2185B'
        }
    }

    public getCategoryColor(category: string) {
        if (this.categoryColors.hasOwnProperty(category)) {
            return this.categoryColors[category];
        } else {
            this.categoryColors[category] = this.generateNewColor();
            return this.categoryColors[category];
        }
    }

    public generateNewColor() {
        return this.availableColors[Math.floor(Math.random() * this.availableColors.length)];
    }

}


// WEBPACK FOOTER //
// ./src/providers/colorCategories.ts